import { keyframes, styled } from "styled-components";

import LoadingComponent from "@/assets/icons/loading.svg?react";

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Loading = styled(LoadingComponent)`
  width: 35%;
  height: 35%;
  align-self: center;
  animation: ${spin} 1s linear infinite;
  & > circle {
    opacity: 0.25;
  }
  & > path {
    opacity: 0.75;
  }
`;

export default {
  Loading,
};
